// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import ThankYou from './pages/thankyou/thankyou';
import PlayerRules from './pages/rules/rules';
import USER from './pages/dddUI/user';
import Editor from './admin/pages/editor/editor';
import Pairs from './admin/pages/pairs/pairs';
import Words from './admin/pages/words/words';
import Jigsaw from './admin/pages/jigsaw/jigsaw';
import ThinkFast from './pages/thinkfast/ThinkFast';
import ThinkSimple from './pages/thinksimple/ThinkSimple';
import ThinkCloser from './pages/thinkcloser/ThinkCloser';
import PuzzleGame from './pages/puzzle/PuzzleGame';
import CopySession from './pages/copySession/copySession';

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const path = location.pathname;
    if (path.startsWith("/admin")) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        {/* Explicit paths (most specific first) so /admin always = theme admin, never the superadmin login */}
        <Route path="/admin/superadmin" element={<LoginPage />} />
        {/* The admin stages, in the order of the original panel: Home, Stage 1, 2, 3, 4 */}
        <Route path="/admin/rules" element={<Admin><Rules /></Admin>} />
        <Route path="/admin/editor" element={<Admin><Editor /></Admin>} />
        <Route path="/admin/questions" element={<Admin><Pairs /></Admin>} />
        <Route path="/admin/words" element={<Admin><Words /></Admin>} />
        <Route path="/admin/jigsaw" element={<Admin><Jigsaw /></Admin>} />
        <Route path="/admin" element={<Admin><Home /></Admin>} />

        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<PlayerRules />} />
              <Route path="/think-fast" element={<ThinkFast />} />
              <Route path="/think-simple" element={<ThinkSimple />} />
              <Route path="/think-closer" element={<ThinkCloser />} />
              <Route path="/puzzle-game" element={<PuzzleGame />} />
              <Route path="/copy-session" element={<CopySession />} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
